import { Styles, css, extractTransition, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  content: css`
    width: 420px;
    user-select: auto;
  `,
  header: css`
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  `,
  body: css`
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 38px 0;
  `,
  footer: css`
    justify-content: space-between;
  `,
  button: ({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding: 13px 12px;

    width: 165px;
    height: 42px;

    border-radius: 4px;
    cursor: pointer;

    color: ${theme.colors.neutral.variant[70]};

    ${extractTransition((f) => f.cubic, { duration: 220, property: 'color' })}

    &:before {
      z-index: 0;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 165px;
      height: 42px;
      background-color: white;

      border: 1px solid ${theme.colors.neutral.variant[20]};
      border-radius: 8px;
    }

    &:after {
      z-index: 0;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 156px;
      height: 34px;
      border-radius: 4px;
      background-color: ${theme.colors.secondary.emerald[10]};
      opacity: 0;

      ${extractTransition((f) => f.cubic, { duration: 220, property: 'opacity' })}
    }

    &:hover {
      color: ${theme.colors.secondary.emerald[60]};

      &:after {
        opacity: 1;
      }
    }

    &:active {
      &:after {
        background-color: ${theme.colors.secondary.emerald[20]};
      }
    }

    & > * {
      z-index: 2;
    }
  `,
  buttonRobinJr: ({ theme }) => css`
    color: ${theme.colors.primary.fuchsia[50]};

    &:hover,
    &:active {
      color: ${theme.colors.primary.fuchsia[60]};
    }

    &:after {
      background-color: ${theme.colors.primary.fuchsia[20]};
    }

    &:active {
      &:after {
        background-color: ${theme.colors.primary.fuchsia[30]};
      }
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
